import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'table-basic-widget',
  templateUrl: './table-basic-widget.component.html',
  styleUrls: ['./table-basic-widget.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class TableBasicWidgetComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
